import React, { useEffect, useState } from 'react';

import './Loading.scss';

export function Loading({
  inline = false,
  video = false,
  onClose = () => {},
}: {
  inline?: boolean;
  video?: boolean;
  onClose?: (value: any) => void;
}) {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className={`loading-container ${inline ? 'inline' : ''}`}>
      <div className="loading loadingEffect">
        {video ? (
          <video autoPlay muted onEnded={() => onClose()}>
            <source src="/walletscan-pitchdeck-video.mp4" type="video/mp4" />
          </video>
        ) : !inline ? (
          <img src={`/images/icon-${theme}.svg`} />
        ) : (
          <img src={`/images/icon-${theme}.svg`} />
        )}
      </div>
    </div>
  );
}
